import { ApolloClient } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";
import getApolloClient from "../client";

const MUTATION = graphql(`
  mutation upload($id: ID!, $finished: Boolean!, $stream: Boolean) {
    upload: uploadRecord(id: $id, finished: $finished, stream: $stream) {
      uri: uploadPath
      stream
      streamToken
    }
  }
`);

type Data = ResultOf<typeof MUTATION>;
type Variables = VariablesOf<typeof MUTATION>;

export const useRecordUploadMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};

export const recordUploadMutate = (
  options: Omit<ApolloClient.MutateOptions<Data, Variables>, "mutation">,
): Promise<ApolloClient.MutateResult<Data>> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return getApolloClient().mutate<Data, Variables>({
    ...options,
    mutation: MUTATION,
  });
};
